import {
  createContext,
  useCallback,
  useContext,
  useState,
  useEffect,
} from "react";
import Toast from "../components/Toast";
import { setToastHandler } from "../utils/toastService";

const ToastContext = createContext(null);

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({
    visible: false,
    message: "",
    type: "error",
  });

  const showToast = useCallback((message, options = {}) => {
    setToast({
      visible: true,
      message,
      type: options.type || "error",
    });

    setTimeout(() => {
      setToast((prev) => ({ ...prev, visible: false }));
    }, options.duration || 2000);
  }, []);

  useEffect(() => {
    setToastHandler(showToast);
  }, [showToast]);

  return (
    <ToastContext.Provider value={{ showToast }}>
      <Toast {...toast} />
      {children}
    </ToastContext.Provider>
  );
};

export const useToastContext = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used inside ToastProvider");
  }
  return context;
};
